import {useRoomPreview} from 'components/customer/RoomPlanner/components/helpers/RoomPreview';
import {getIsEditingRoomDimension} from 'components/customer/RoomPlanner/store/roomPlannerSlice';
import React from 'react';
import {
    mobileLandscape,
    mobilePortrait,
    tabletLandscape,
    tabletPortrait,
    tablets,
    touchDevices,
} from 'shared/Breakpoints';
import {useAppSelector} from 'store/customer';
import styled from 'styled-components';

export const Note = () => {
    const isEditingRoom = useAppSelector(getIsEditingRoomDimension);
    const isRoomPreview = useRoomPreview();

    return (
        <Container
            $isEditingRoom={isEditingRoom}
            $isRoomPreview={isRoomPreview}>
            <strong>Note:</strong> The 3D preview is for demonstration purposes
            only. Appliances are shown for visual reference and are not included
            in your order. Final product composition may change at manufacture.
            All measurements are in mm.
        </Container>
    );
};

const Container = styled.div<{
    $isEditingRoom: boolean;
    $isRoomPreview: boolean;
}>`
    position: fixed;
    bottom: 8px;
    left: 50%;
    transform: translateX(-47.5%);
    color: grey;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    padding: 8px 16px;
    z-index: 99;
    pointer-events: none;
    white-space: nowrap;

    ${mobileLandscape<{$isRoomPreview: boolean}>`
        left: initial !important;
        right: 0;
        transform: initial !important;
        width: 50% !important;
        white-space: normal;
        text-align: right !important;
        bottom: ${({$isRoomPreview}) =>
            $isRoomPreview ? '8px' : '10px'} !important;
    `}

    ${mobilePortrait<{$isRoomPreview: boolean}>`
        /* Leave the right edge clear for the share and help buttons. */
        left: 8px;
        right: ${({$isRoomPreview}) => ($isRoomPreview ? '8px' : '116px')};
        width: auto;
        transform: none;
        text-align: center;
        white-space: normal;
        font-size: 10px;
        line-height: 1.15;
        padding: 0 4px;
        bottom: ${({$isRoomPreview}) => ($isRoomPreview ? '8px' : '108px')};
    `}

    ${tablets`
        width: 57%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        white-space: normal;
        font-size: 10px;
        line-height: 1.15;
        padding: 0 8px;
    `}

    ${tabletPortrait<{$isRoomPreview: boolean}>`
        bottom: ${({$isRoomPreview}) => ($isRoomPreview ? '8px' : '84px')};
    `}

    ${tabletLandscape`
        bottom: 15px;
    `}

    ${touchDevices<{$isEditingRoom: boolean; $isRoomPreview: boolean}>`
        ${({$isEditingRoom, $isRoomPreview}) => {
            if ($isEditingRoom && !$isRoomPreview) {
                return `
                bottom: 60px !important;
            `;
            }
        }}
    `}

    @media (min-width: 768px) and (max-width: 1180px) and (pointer: fine) {
        width: 70%;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        white-space: normal;
        line-height: 1.3;
        bottom: ${({$isEditingRoom, $isRoomPreview}) =>
            $isEditingRoom && !$isRoomPreview ? '120px' : '16px'};
    }
`;
